(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'Kotlin-Immutable-Collections-kotlinx-collections-immutable'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'Kotlin-Immutable-Collections-kotlinx-collections-immutable'.");
    }
    globalThis['Kotlin-Immutable-Collections-kotlinx-collections-immutable'] = factory(typeof globalThis['Kotlin-Immutable-Collections-kotlinx-collections-immutable'] === 'undefined' ? {} : globalThis['Kotlin-Immutable-Collections-kotlinx-collections-immutable'], globalThis['kotlin-kotlin-stdlib']);
  }
}(function (_, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var protoOf = kotlin_kotlin.$_$.eh;
  var KtMap = kotlin_kotlin.$_$.g7;
  var initMetadataForInterface = kotlin_kotlin.$_$.gg;
  var VOID = kotlin_kotlin.$_$.d;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var isInterface = kotlin_kotlin.$_$.rg;
  var putAll = kotlin_kotlin.$_$.kb;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var initMetadataForCompanion = kotlin_kotlin.$_$.dg;
  var equals = kotlin_kotlin.$_$.sf;
  var AbstractMap = kotlin_kotlin.$_$.r6;
  var hashCode = kotlin_kotlin.$_$.bg;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var AbstractMutableMap = kotlin_kotlin.$_$.u6;
  var KtMutableMap = kotlin_kotlin.$_$.k7;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.u5;
  var ConcurrentModificationException_init_$Create$ = kotlin_kotlin.$_$.a5;
  var MutableEntry = kotlin_kotlin.$_$.j7;
  var UnsupportedOperationException_init_$Create$ = kotlin_kotlin.$_$.n6;
  var AbstractMutableSet = kotlin_kotlin.$_$.v6;
  var KtMutableSet = kotlin_kotlin.$_$.l7;
  var AbstractMutableCollection = kotlin_kotlin.$_$.s6;
  var MutableCollection = kotlin_kotlin.$_$.h7;
  var Entry = kotlin_kotlin.$_$.f7;
  var NoSuchElementException_init_$Create$ = kotlin_kotlin.$_$.b6;
  var toString = kotlin_kotlin.$_$.hp;
  var AbstractSet = kotlin_kotlin.$_$.w6;
  var Collection = kotlin_kotlin.$_$.y6;
  var KtSet = kotlin_kotlin.$_$.n7;
  var AbstractCollection = kotlin_kotlin.$_$.p6;
  var objectCreate = kotlin_kotlin.$_$.dh;
  var until = kotlin_kotlin.$_$.mi;
  var step = kotlin_kotlin.$_$.li;
  var copyOf = kotlin_kotlin.$_$.v8;
  var countOneBits = kotlin_kotlin.$_$.io;
  var takeLowestOneBit = kotlin_kotlin.$_$.ap;
  var IllegalStateException_init_$Create$_0 = kotlin_kotlin.$_$.w5;
  var arrayCopy = kotlin_kotlin.$_$.q7;
  var toString_0 = kotlin_kotlin.$_$.hh;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.p5;
  var initMetadataForObject = kotlin_kotlin.$_$.ig;
  var AssertionError_init_$Create$ = kotlin_kotlin.$_$.z4;
  //endregion
  //region block: pre-declaration
  initMetadataForInterface(PersistentMap, 'PersistentMap', VOID, VOID, [KtMap]);
  initMetadataForCompanion(Companion);
  initMetadataForClass(PersistentHashMap, 'PersistentHashMap', VOID, AbstractMap, [PersistentMap]);
  initMetadataForClass(PersistentHashMapBuilder, 'PersistentHashMapBuilder', VOID, AbstractMutableMap, [KtMutableMap]);
  initMetadataForClass(PersistentHashMapBuilderEntriesIterator, 'PersistentHashMapBuilderEntriesIterator');
  initMetadataForClass(PersistentHashMapBaseIterator, 'PersistentHashMapBaseIterator');
  initMetadataForClass(PersistentHashMapBuilderBaseIterator, 'PersistentHashMapBuilderBaseIterator', VOID, PersistentHashMapBaseIterator);
  initMetadataForClass(PersistentHashMapBuilderKeysIterator, 'PersistentHashMapBuilderKeysIterator', VOID, PersistentHashMapBuilderBaseIterator);
  initMetadataForClass(PersistentHashMapBuilderValuesIterator, 'PersistentHashMapBuilderValuesIterator', VOID, PersistentHashMapBuilderBaseIterator);
  initMetadataForClass(TrieNodeBaseIterator, 'TrieNodeBaseIterator');
  initMetadataForClass(TrieNodeMutableEntriesIterator, 'TrieNodeMutableEntriesIterator', VOID, TrieNodeBaseIterator);
  initMetadataForClass(MapEntry, 'MapEntry', VOID, VOID, [Entry]);
  initMetadataForClass(MutableMapEntry, 'MutableMapEntry', VOID, MapEntry, [MutableEntry]);
  initMetadataForClass(AbstractMapBuilderEntries, 'AbstractMapBuilderEntries', VOID, AbstractMutableSet);
  initMetadataForClass(PersistentHashMapBuilderEntries, 'PersistentHashMapBuilderEntries', VOID, AbstractMapBuilderEntries);
  initMetadataForClass(PersistentHashMapBuilderKeys, 'PersistentHashMapBuilderKeys', VOID, AbstractMutableSet, [KtMutableSet]);
  initMetadataForClass(PersistentHashMapBuilderValues, 'PersistentHashMapBuilderValues', VOID, AbstractMutableCollection, [MutableCollection]);
  initMetadataForClass(PersistentHashMapKeysIterator, 'PersistentHashMapKeysIterator', VOID, PersistentHashMapBaseIterator);
  initMetadataForClass(PersistentHashMapValuesIterator, 'PersistentHashMapValuesIterator', VOID, PersistentHashMapBaseIterator);
  initMetadataForClass(PersistentHashMapEntriesIterator, 'PersistentHashMapEntriesIterator', VOID, PersistentHashMapBaseIterator);
  initMetadataForClass(TrieNodeKeysIterator, 'TrieNodeKeysIterator', TrieNodeKeysIterator, TrieNodeBaseIterator);
  initMetadataForClass(TrieNodeValuesIterator, 'TrieNodeValuesIterator', TrieNodeValuesIterator, TrieNodeBaseIterator);
  initMetadataForClass(TrieNodeEntriesIterator, 'TrieNodeEntriesIterator', TrieNodeEntriesIterator, TrieNodeBaseIterator);
  initMetadataForClass(PersistentHashMapKeys, 'PersistentHashMapKeys', VOID, AbstractSet, [Collection, KtSet]);
  initMetadataForClass(PersistentHashMapValues, 'PersistentHashMapValues', VOID, AbstractCollection, [Collection]);
  initMetadataForClass(PersistentHashMapEntries, 'PersistentHashMapEntries', VOID, AbstractSet, [Collection, KtSet]);
  initMetadataForClass(ModificationResult, 'ModificationResult');
  initMetadataForCompanion(Companion_0);
  initMetadataForClass(TrieNode, 'TrieNode');
  initMetadataForClass(PersistentOrderedMap, 'PersistentOrderedMap', VOID, AbstractMap, [PersistentMap]);
  initMetadataForClass(PersistentOrderedMapBuilder, 'PersistentOrderedMapBuilder', VOID, AbstractMutableMap, [KtMutableMap]);
  initMetadataForObject(MapImplementation, 'MapImplementation');
  initMetadataForClass(MutabilityOwnership, 'MutabilityOwnership', MutabilityOwnership);
  initMetadataForClass(DeltaCounter, 'DeltaCounter', DeltaCounter);
  //endregion
  function PersistentMap() {
  }
  function persistentHashMapOf() {
    return Companion_getInstance().uvf();
  }
  function persistentHashMapOf_0(pairs) {
    // Inline function 'kotlinx.collections.immutable.mutate' call
    var this_0 = Companion_getInstance().uvf();
    // Inline function 'kotlin.apply' call
    var this_1 = (isInterface(this_0, PersistentMap) ? this_0 : THROW_CCE()).a3d();
    // Inline function 'kotlin.collections.plusAssign' call
    putAll(this_1, pairs);
    return this_1.g3d();
  }
  function createEntries($this) {
    return new PersistentHashMapEntries($this);
  }
  function Companion() {
    Companion_instance = this;
    this.tvf_1 = new PersistentHashMap(Companion_getInstance_0().vvf_1, 0);
  }
  protoOf(Companion).uvf = function () {
    var tmp = this.tvf_1;
    return tmp instanceof PersistentHashMap ? tmp : THROW_CCE();
  };
  var Companion_instance;
  function Companion_getInstance() {
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function PersistentHashMap$equals$lambda(a, b) {
    return equals(a, b.wvf_1);
  }
  function PersistentHashMap$equals$lambda_0(a, b) {
    return equals(a, b.wvf_1);
  }
  function PersistentHashMap$equals$lambda_1(a, b) {
    return equals(a, b);
  }
  function PersistentHashMap$equals$lambda_2(a, b) {
    return equals(a, b);
  }
  function PersistentHashMap(node, size) {
    Companion_getInstance();
    AbstractMap.call(this);
    this.bvg_1 = node;
    this.cvg_1 = size;
  }
  protoOf(PersistentHashMap).n1 = function () {
    return this.cvg_1;
  };
  protoOf(PersistentHashMap).x2 = function () {
    return new PersistentHashMapKeys(this);
  };
  protoOf(PersistentHashMap).y2 = function () {
    return new PersistentHashMapValues(this);
  };
  protoOf(PersistentHashMap).s1 = function () {
    return createEntries(this);
  };
  protoOf(PersistentHashMap).u2 = function (key) {
    // Inline function 'kotlin.hashCode' call
    var tmp1_elvis_lhs = key == null ? null : hashCode(key);
    var tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    return this.bvg_1.y4w(tmp$ret$0, key, 0);
  };
  protoOf(PersistentHashMap).w2 = function (key) {
    // Inline function 'kotlin.hashCode' call
    var tmp1_elvis_lhs = key == null ? null : hashCode(key);
    var tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    return this.bvg_1.z4w(tmp$ret$0, key, 0);
  };
  protoOf(PersistentHashMap).z2 = function (key, value) {
    // Inline function 'kotlin.hashCode' call
    var tmp1_elvis_lhs = key == null ? null : hashCode(key);
    var tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp0_elvis_lhs = this.bvg_1.a4x(tmp$ret$0, key, value, 0);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return this;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var newNodeResult = tmp;
    return new PersistentHashMap(newNodeResult.hvg_1, this.cvg_1 + newNodeResult.ivg_1 | 0);
  };
  protoOf(PersistentHashMap).a3 = function (key) {
    // Inline function 'kotlin.hashCode' call
    var tmp1_elvis_lhs = key == null ? null : hashCode(key);
    var tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var newNode = this.bvg_1.d4x(tmp$ret$0, key, 0);
    if (this.bvg_1 === newNode) {
      return this;
    }
    if (newNode == null) {
      return Companion_getInstance().uvf();
    }
    return new PersistentHashMap(newNode, this.cvg_1 - 1 | 0);
  };
  protoOf(PersistentHashMap).svf = function (m) {
    if (m.r())
      return this;
    // Inline function 'kotlinx.collections.immutable.mutate' call
    // Inline function 'kotlin.apply' call
    var this_0 = (isInterface(this, PersistentMap) ? this : THROW_CCE()).a3d();
    this_0.b3(m);
    return this_0.g3d();
  };
  protoOf(PersistentHashMap).a3d = function () {
    return new PersistentHashMapBuilder(this);
  };
  protoOf(PersistentHashMap).equals = function (other) {
    if (other === this)
      return true;
    if (!(!(other == null) ? isInterface(other, KtMap) : false))
      return false;
    if (!(this.cvg_1 === other.n1()))
      return false;
    var tmp;
    if (other instanceof PersistentOrderedMap) {
      tmp = this.bvg_1.tvg(other.bvh_1.bvg_1, PersistentHashMap$equals$lambda);
    } else {
      if (other instanceof PersistentOrderedMapBuilder) {
        var tmp_0 = other.yvg_1.pvg_1;
        tmp = this.bvg_1.tvg(tmp_0, PersistentHashMap$equals$lambda_0);
      } else {
        if (other instanceof PersistentHashMap) {
          tmp = this.bvg_1.tvg(other.bvg_1, PersistentHashMap$equals$lambda_1);
        } else {
          if (other instanceof PersistentHashMapBuilder) {
            var tmp_1 = other.pvg_1;
            tmp = this.bvg_1.tvg(tmp_1, PersistentHashMap$equals$lambda_2);
          } else {
            tmp = protoOf(AbstractMap).equals.call(this, other);
          }
        }
      }
    }
    return tmp;
  };
  protoOf(PersistentHashMap).hashCode = function () {
    return protoOf(AbstractMap).hashCode.call(this);
  };
  function PersistentHashMapBuilder$equals$lambda(a, b) {
    return equals(a, b);
  }
  function PersistentHashMapBuilder$equals$lambda_0(a, b) {
    return equals(a, b);
  }
  function PersistentHashMapBuilder$equals$lambda_1(a, b) {
    return equals(a, b.wvf_1);
  }
  function PersistentHashMapBuilder$equals$lambda_2(a, b) {
    return equals(a, b.wvf_1);
  }
  function PersistentHashMapBuilder(map) {
    AbstractMutableMap.call(this);
    this.nvg_1 = map;
    this.ovg_1 = new MutabilityOwnership();
    this.pvg_1 = map.bvg_1;
    this.qvg_1 = null;
    this.rvg_1 = 0;
    this.svg_1 = map.cvg_1;
  }
  protoOf(PersistentHashMapBuilder).cvh = function (value) {
    if (!(value === this.pvg_1)) {
      this.pvg_1 = value;
      this.nvg_1 = null;
    }
  };
  protoOf(PersistentHashMapBuilder).o4x = function (value) {
    this.svg_1 = value;
    this.rvg_1 = this.rvg_1 + 1 | 0;
  };
  protoOf(PersistentHashMapBuilder).n1 = function () {
    return this.svg_1;
  };
  protoOf(PersistentHashMapBuilder).g3d = function () {
    var tmp0_elvis_lhs = this.nvg_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.run' call
      var newlyBuiltMap = new PersistentHashMap(this.pvg_1, this.svg_1);
      this.nvg_1 = newlyBuiltMap;
      this.ovg_1 = new MutabilityOwnership();
      tmp = newlyBuiltMap;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(PersistentHashMapBuilder).s1 = function () {
    return new PersistentHashMapBuilderEntries(this);
  };
  protoOf(PersistentHashMapBuilder).x2 = function () {
    return new PersistentHashMapBuilderKeys(this);
  };
  protoOf(PersistentHashMapBuilder).y2 = function () {
    return new PersistentHashMapBuilderValues(this);
  };
  protoOf(PersistentHashMapBuilder).u2 = function (key) {
    var tmp = this.pvg_1;
    // Inline function 'kotlin.hashCode' call
    var tmp1_elvis_lhs = key == null ? null : hashCode(key);
    var tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    return tmp.y4w(tmp$ret$0, key, 0);
  };
  protoOf(PersistentHashMapBuilder).w2 = function (key) {
    var tmp = this.pvg_1;
    // Inline function 'kotlin.hashCode' call
    var tmp1_elvis_lhs = key == null ? null : hashCode(key);
    var tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    return tmp.z4w(tmp$ret$0, key, 0);
  };
  protoOf(PersistentHashMapBuilder).z2 = function (key, value) {
    this.qvg_1 = null;
    var tmp = this.pvg_1;
    // Inline function 'kotlin.hashCode' call
    var tmp1_elvis_lhs = key == null ? null : hashCode(key);
    var tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    this.cvh(tmp.dvh(tmp$ret$0, key, value, 0, this));
    return this.qvg_1;
  };
  protoOf(PersistentHashMapBuilder).b3 = function (from) {
    if (from.r())
      return Unit_instance;
    var tmp0_elvis_lhs = from instanceof PersistentHashMap ? from : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp1_safe_receiver = from instanceof PersistentHashMapBuilder ? from : null;
      tmp = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.g3d();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var map = tmp;
    if (!(map == null)) {
      var intersectionCounter = new DeltaCounter();
      var oldSize = this.svg_1;
      var tmp_0 = this.pvg_1;
      var tmp_1 = map.bvg_1;
      this.cvh(tmp_0.evh(tmp_1 instanceof TrieNode ? tmp_1 : THROW_CCE(), 0, intersectionCounter, this));
      var newSize = (oldSize + map.cvg_1 | 0) - intersectionCounter.fvh_1 | 0;
      if (!(oldSize === newSize)) {
        this.o4x(newSize);
      }
    } else {
      protoOf(AbstractMutableMap).b3.call(this, from);
    }
  };
  protoOf(PersistentHashMapBuilder).a3 = function (key) {
    this.qvg_1 = null;
    var tmp = this.pvg_1;
    // Inline function 'kotlin.hashCode' call
    var tmp1_elvis_lhs = key == null ? null : hashCode(key);
    var tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp0_elvis_lhs = tmp.gvh(tmp$ret$0, key, 0, this);
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      var tmp_1 = Companion_getInstance_0().vvf_1;
      tmp_0 = tmp_1 instanceof TrieNode ? tmp_1 : THROW_CCE();
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    this.cvh(tmp_0);
    return this.qvg_1;
  };
  protoOf(PersistentHashMapBuilder).t4x = function (key, value) {
    var oldSize = this.svg_1;
    var tmp = this.pvg_1;
    // Inline function 'kotlin.hashCode' call
    var tmp1_elvis_lhs = key == null ? null : hashCode(key);
    var tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp0_elvis_lhs = tmp.hvh(tmp$ret$0, key, value, 0, this);
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      var tmp_1 = Companion_getInstance_0().vvf_1;
      tmp_0 = tmp_1 instanceof TrieNode ? tmp_1 : THROW_CCE();
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    this.cvh(tmp_0);
    return !(oldSize === this.svg_1);
  };
  protoOf(PersistentHashMapBuilder).c3 = function () {
    var tmp = Companion_getInstance_0().vvf_1;
    this.cvh(tmp instanceof TrieNode ? tmp : THROW_CCE());
    this.o4x(0);
  };
  protoOf(PersistentHashMapBuilder).equals = function (other) {
    if (other === this)
      return true;
    if (!(!(other == null) ? isInterface(other, KtMap) : false))
      return false;
    if (!(this.svg_1 === other.n1()))
      return false;
    var tmp;
    if (other instanceof PersistentHashMap) {
      var tmp_0 = this.pvg_1;
      tmp = tmp_0.tvg(other.bvg_1, PersistentHashMapBuilder$equals$lambda);
    } else {
      if (other instanceof PersistentHashMapBuilder) {
        var tmp_1 = this.pvg_1;
        var tmp_2 = other.pvg_1;
        tmp = tmp_1.tvg(tmp_2, PersistentHashMapBuilder$equals$lambda_0);
      } else {
        if (other instanceof PersistentOrderedMap) {
          var tmp_3 = this.pvg_1;
          tmp = tmp_3.tvg(other.bvh_1.bvg_1, PersistentHashMapBuilder$equals$lambda_1);
        } else {
          if (other instanceof PersistentOrderedMapBuilder) {
            var tmp_4 = this.pvg_1;
            var tmp_5 = other.yvg_1.pvg_1;
            tmp = tmp_4.tvg(tmp_5, PersistentHashMapBuilder$equals$lambda_2);
          } else {
            tmp = MapImplementation_instance.ivh(this, other);
          }
        }
      }
    }
    return tmp;
  };
  protoOf(PersistentHashMapBuilder).hashCode = function () {
    return MapImplementation_instance.jvh(this);
  };
  function PersistentHashMapBuilderEntriesIterator(builder) {
    var tmp = this;
    var tmp_0 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = Array(8);
    while (tmp_0 < 8) {
      tmp_1[tmp_0] = new TrieNodeMutableEntriesIterator(this);
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.kvh_1 = new PersistentHashMapBuilderBaseIterator(builder, tmp_1);
  }
  protoOf(PersistentHashMapBuilderEntriesIterator).u = function () {
    return this.kvh_1.u();
  };
  protoOf(PersistentHashMapBuilderEntriesIterator).v = function () {
    return this.kvh_1.v();
  };
  protoOf(PersistentHashMapBuilderEntriesIterator).l4 = function () {
    return this.kvh_1.l4();
  };
  function PersistentHashMapBuilderKeysIterator(builder) {
    var tmp = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_0 = Array(8);
    while (tmp < 8) {
      tmp_0[tmp] = new TrieNodeKeysIterator();
      tmp = tmp + 1 | 0;
    }
    PersistentHashMapBuilderBaseIterator.call(this, builder, tmp_0);
  }
  function PersistentHashMapBuilderValuesIterator(builder) {
    var tmp = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_0 = Array(8);
    while (tmp < 8) {
      tmp_0[tmp] = new TrieNodeValuesIterator();
      tmp = tmp + 1 | 0;
    }
    PersistentHashMapBuilderBaseIterator.call(this, builder, tmp_0);
  }
  function resetPath($this, keyHash, node, key, pathIndex, removedKeyHash, afterRemove) {
    removedKeyHash = removedKeyHash === VOID ? 0 : removedKeyHash;
    afterRemove = afterRemove === VOID ? false : afterRemove;
    var shift = imul(pathIndex, 5);
    if (shift > 30) {
      $this.lvh_1[pathIndex].k4y(node.gvg_1, node.gvg_1.length, 0);
      while (!equals($this.lvh_1[pathIndex].g4y(), key)) {
        $this.lvh_1[pathIndex].l4y();
      }
      $this.mvh_1 = pathIndex;
      return Unit_instance;
    }
    var keyPositionMask = 1 << indexSegment(keyHash, shift);
    if (node.avi(keyPositionMask)) {
      var keyIndex = node.yvh(keyPositionMask);
      var removedKeyPositionMask = afterRemove ? 1 << indexSegment(removedKeyHash, shift) : 0;
      if (keyPositionMask === removedKeyPositionMask && pathIndex < $this.mvh_1) {
        var tmp = $this.lvh_1[$this.mvh_1];
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$0 = [node.gvg_1[keyIndex], node.gvg_1[keyIndex + 1 | 0]];
        tmp.w4y(tmp$ret$0, 2);
        return Unit_instance;
      }
      $this.lvh_1[pathIndex].k4y(node.gvg_1, imul(2, node.zvh()), keyIndex);
      $this.mvh_1 = pathIndex;
      return Unit_instance;
    }
    var nodeIndex = node.bvi(keyPositionMask);
    var targetNode = node.cvi(nodeIndex);
    $this.lvh_1[pathIndex].k4y(node.gvg_1, imul(2, node.zvh()), nodeIndex);
    resetPath($this, keyHash, targetNode, key, pathIndex + 1 | 0, removedKeyHash, afterRemove);
  }
  function checkNextWasInvoked($this) {
    if (!$this.tvh_1)
      throw IllegalStateException_init_$Create$();
  }
  function checkForComodification($this) {
    if (!($this.rvh_1.rvg_1 === $this.uvh_1))
      throw ConcurrentModificationException_init_$Create$();
  }
  function PersistentHashMapBuilderBaseIterator(builder, path) {
    PersistentHashMapBaseIterator.call(this, builder.pvg_1, path);
    this.rvh_1 = builder;
    this.svh_1 = null;
    this.tvh_1 = false;
    this.uvh_1 = this.rvh_1.rvg_1;
  }
  protoOf(PersistentHashMapBuilderBaseIterator).v = function () {
    checkForComodification(this);
    this.svh_1 = this.g4y();
    this.tvh_1 = true;
    return protoOf(PersistentHashMapBaseIterator).v.call(this);
  };
  protoOf(PersistentHashMapBuilderBaseIterator).l4 = function () {
    checkNextWasInvoked(this);
    if (this.u()) {
      var currentKey = this.g4y();
      var tmp0 = this.rvh_1;
      // Inline function 'kotlin.collections.remove' call
      var key = this.svh_1;
      (isInterface(tmp0, KtMutableMap) ? tmp0 : THROW_CCE()).a3(key);
      // Inline function 'kotlin.hashCode' call
      var tmp1_elvis_lhs = currentKey == null ? null : hashCode(currentKey);
      var tmp = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
      var tmp_0 = this.rvh_1.pvg_1;
      // Inline function 'kotlin.hashCode' call
      var tmp0_safe_receiver = this.svh_1;
      var tmp1_elvis_lhs_0 = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
      var tmp$ret$2 = tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0;
      resetPath(this, tmp, tmp_0, currentKey, 0, tmp$ret$2, true);
    } else {
      var tmp0_0 = this.rvh_1;
      // Inline function 'kotlin.collections.remove' call
      var key_0 = this.svh_1;
      (isInterface(tmp0_0, KtMutableMap) ? tmp0_0 : THROW_CCE()).a3(key_0);
    }
    this.svh_1 = null;
    this.tvh_1 = false;
    this.uvh_1 = this.rvh_1.rvg_1;
  };
  function TrieNodeMutableEntriesIterator(parentIterator) {
    TrieNodeBaseIterator.call(this);
    this.gvi_1 = parentIterator;
  }
  protoOf(TrieNodeMutableEntriesIterator).v = function () {
    assert(this.v4y());
    this.xvh_1 = this.xvh_1 + 2 | 0;
    return new MutableMapEntry(this.gvi_1, this.vvh_1[this.xvh_1 - 2 | 0], this.vvh_1[this.xvh_1 - 1 | 0]);
  };
  function MutableMapEntry(parentIterator, key, value) {
    MapEntry.call(this, key, value);
    this.jvi_1 = parentIterator;
    this.kvi_1 = value;
  }
  protoOf(MutableMapEntry).u1 = function () {
    return this.kvi_1;
  };
  function PersistentHashMapBuilderEntries(builder) {
    AbstractMapBuilderEntries.call(this);
    this.nvi_1 = builder;
  }
  protoOf(PersistentHashMapBuilderEntries).h4z = function (element) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(PersistentHashMapBuilderEntries).j1 = function (element) {
    return this.h4z((!(element == null) ? isInterface(element, MutableEntry) : false) ? element : THROW_CCE());
  };
  protoOf(PersistentHashMapBuilderEntries).c3 = function () {
    this.nvi_1.c3();
  };
  protoOf(PersistentHashMapBuilderEntries).t = function () {
    return new PersistentHashMapBuilderEntriesIterator(this.nvi_1);
  };
  protoOf(PersistentHashMapBuilderEntries).w6 = function (element) {
    return this.nvi_1.t4x(element.t1(), element.u1());
  };
  protoOf(PersistentHashMapBuilderEntries).n1 = function () {
    return this.nvi_1.svg_1;
  };
  protoOf(PersistentHashMapBuilderEntries).v6 = function (element) {
    return MapImplementation_instance.ovi(this.nvi_1, element);
  };
  function PersistentHashMapBuilderKeys(builder) {
    AbstractMutableSet.call(this);
    this.pvi_1 = builder;
  }
  protoOf(PersistentHashMapBuilderKeys).a7 = function (element) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(PersistentHashMapBuilderKeys).j1 = function (element) {
    return this.a7(element);
  };
  protoOf(PersistentHashMapBuilderKeys).c3 = function () {
    this.pvi_1.c3();
  };
  protoOf(PersistentHashMapBuilderKeys).t = function () {
    return new PersistentHashMapBuilderKeysIterator(this.pvi_1);
  };
  protoOf(PersistentHashMapBuilderKeys).a3 = function (element) {
    if (this.pvi_1.u2(element)) {
      this.pvi_1.a3(element);
      return true;
    }
    return false;
  };
  protoOf(PersistentHashMapBuilderKeys).d3 = function (element) {
    if (!true)
      return false;
    return this.a3(element);
  };
  protoOf(PersistentHashMapBuilderKeys).n1 = function () {
    return this.pvi_1.svg_1;
  };
  protoOf(PersistentHashMapBuilderKeys).d6 = function (element) {
    return this.pvi_1.u2(element);
  };
  protoOf(PersistentHashMapBuilderKeys).m1 = function (element) {
    if (!true)
      return false;
    return this.d6(element);
  };
  function PersistentHashMapBuilderValues(builder) {
    AbstractMutableCollection.call(this);
    this.qvi_1 = builder;
  }
  protoOf(PersistentHashMapBuilderValues).n1 = function () {
    return this.qvi_1.svg_1;
  };
  protoOf(PersistentHashMapBuilderValues).j6 = function (element) {
    return this.qvi_1.v2(element);
  };
  protoOf(PersistentHashMapBuilderValues).m1 = function (element) {
    if (!true)
      return false;
    return this.j6(element);
  };
  protoOf(PersistentHashMapBuilderValues).k6 = function (element) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(PersistentHashMapBuilderValues).j1 = function (element) {
    return this.k6(element);
  };
  protoOf(PersistentHashMapBuilderValues).c3 = function () {
    this.qvi_1.c3();
  };
  protoOf(PersistentHashMapBuilderValues).t = function () {
    return new PersistentHashMapBuilderValuesIterator(this.qvi_1);
  };
  function AbstractMapBuilderEntries() {
    AbstractMutableSet.call(this);
  }
  protoOf(AbstractMapBuilderEntries).s6 = function (element) {
    var tmp = !(element == null) ? element : null;
    if (!(!(tmp == null) ? isInterface(tmp, Entry) : false))
      return false;
    return this.v6(element);
  };
  protoOf(AbstractMapBuilderEntries).m1 = function (element) {
    if (!(!(element == null) ? isInterface(element, Entry) : false))
      return false;
    return this.s6((!(element == null) ? isInterface(element, Entry) : false) ? element : THROW_CCE());
  };
  protoOf(AbstractMapBuilderEntries).u6 = function (element) {
    var tmp = !(element == null) ? element : null;
    if (!(!(tmp == null) ? isInterface(tmp, Entry) : false))
      return false;
    return this.w6(element);
  };
  protoOf(AbstractMapBuilderEntries).d3 = function (element) {
    if (!(!(element == null) ? isInterface(element, Entry) : false))
      return false;
    return this.u6((!(element == null) ? isInterface(element, Entry) : false) ? element : THROW_CCE());
  };
  function PersistentHashMapKeysIterator(node) {
    var tmp = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_0 = Array(8);
    while (tmp < 8) {
      tmp_0[tmp] = new TrieNodeKeysIterator();
      tmp = tmp + 1 | 0;
    }
    PersistentHashMapBaseIterator.call(this, node, tmp_0);
  }
  function PersistentHashMapValuesIterator(node) {
    var tmp = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_0 = Array(8);
    while (tmp < 8) {
      tmp_0[tmp] = new TrieNodeValuesIterator();
      tmp = tmp + 1 | 0;
    }
    PersistentHashMapBaseIterator.call(this, node, tmp_0);
  }
  function PersistentHashMapEntriesIterator(node) {
    var tmp = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_0 = Array(8);
    while (tmp < 8) {
      tmp_0[tmp] = new TrieNodeEntriesIterator();
      tmp = tmp + 1 | 0;
    }
    PersistentHashMapBaseIterator.call(this, node, tmp_0);
  }
  function moveToNextNodeWithData($this, pathIndex) {
    if ($this.lvh_1[pathIndex].v4y()) {
      return pathIndex;
    }
    if ($this.lvh_1[pathIndex].x4y()) {
      var node = $this.lvh_1[pathIndex].y4y();
      if (pathIndex === 6) {
        $this.lvh_1[pathIndex + 1 | 0].w4y(node.gvg_1, node.gvg_1.length);
      } else {
        $this.lvh_1[pathIndex + 1 | 0].w4y(node.gvg_1, imul(2, node.zvh()));
      }
      return moveToNextNodeWithData($this, pathIndex + 1 | 0);
    }
    return -1;
  }
  function ensureNextEntryIsReady($this) {
    if ($this.lvh_1[$this.mvh_1].v4y()) {
      return Unit_instance;
    }
    var inductionVariable = $this.mvh_1;
    if (0 <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var result = moveToNextNodeWithData($this, i);
        if (result === -1 && $this.lvh_1[i].x4y()) {
          $this.lvh_1[i].z4y();
          result = moveToNextNodeWithData($this, i);
        }
        if (!(result === -1)) {
          $this.mvh_1 = result;
          return Unit_instance;
        }
        if (i > 0) {
          $this.lvh_1[i - 1 | 0].z4y();
        }
        $this.lvh_1[i].w4y(Companion_getInstance_0().vvf_1.gvg_1, 0);
      }
       while (0 <= inductionVariable);
    $this.nvh_1 = false;
  }
  function checkHasNext($this) {
    if (!$this.u())
      throw NoSuchElementException_init_$Create$();
  }
  function PersistentHashMapBaseIterator(node, path) {
    this.lvh_1 = path;
    this.mvh_1 = 0;
    this.nvh_1 = true;
    this.lvh_1[0].w4y(node.gvg_1, imul(2, node.zvh()));
    this.mvh_1 = 0;
    ensureNextEntryIsReady(this);
  }
  protoOf(PersistentHashMapBaseIterator).g4y = function () {
    checkHasNext(this);
    return this.lvh_1[this.mvh_1].g4y();
  };
  protoOf(PersistentHashMapBaseIterator).u = function () {
    return this.nvh_1;
  };
  protoOf(PersistentHashMapBaseIterator).v = function () {
    checkHasNext(this);
    var result = this.lvh_1[this.mvh_1].v();
    ensureNextEntryIsReady(this);
    return result;
  };
  function TrieNodeBaseIterator() {
    this.vvh_1 = Companion_getInstance_0().vvf_1.gvg_1;
    this.wvh_1 = 0;
    this.xvh_1 = 0;
  }
  protoOf(TrieNodeBaseIterator).k4y = function (buffer, dataSize, index) {
    this.vvh_1 = buffer;
    this.wvh_1 = dataSize;
    this.xvh_1 = index;
  };
  protoOf(TrieNodeBaseIterator).w4y = function (buffer, dataSize) {
    this.k4y(buffer, dataSize, 0);
  };
  protoOf(TrieNodeBaseIterator).v4y = function () {
    return this.xvh_1 < this.wvh_1;
  };
  protoOf(TrieNodeBaseIterator).g4y = function () {
    assert(this.v4y());
    return this.vvh_1[this.xvh_1];
  };
  protoOf(TrieNodeBaseIterator).l4y = function () {
    assert(this.v4y());
    this.xvh_1 = this.xvh_1 + 2 | 0;
  };
  protoOf(TrieNodeBaseIterator).x4y = function () {
    assert(this.xvh_1 >= this.wvh_1);
    return this.xvh_1 < this.vvh_1.length;
  };
  protoOf(TrieNodeBaseIterator).y4y = function () {
    assert(this.x4y());
    var tmp = this.vvh_1[this.xvh_1];
    return tmp instanceof TrieNode ? tmp : THROW_CCE();
  };
  protoOf(TrieNodeBaseIterator).z4y = function () {
    assert(this.x4y());
    this.xvh_1 = this.xvh_1 + 1 | 0;
  };
  protoOf(TrieNodeBaseIterator).u = function () {
    return this.v4y();
  };
  function TrieNodeKeysIterator() {
    TrieNodeBaseIterator.call(this);
  }
  protoOf(TrieNodeKeysIterator).v = function () {
    assert(this.v4y());
    this.xvh_1 = this.xvh_1 + 2 | 0;
    return this.vvh_1[this.xvh_1 - 2 | 0];
  };
  function TrieNodeValuesIterator() {
    TrieNodeBaseIterator.call(this);
  }
  protoOf(TrieNodeValuesIterator).v = function () {
    assert(this.v4y());
    this.xvh_1 = this.xvh_1 + 2 | 0;
    return this.vvh_1[this.xvh_1 - 1 | 0];
  };
  function TrieNodeEntriesIterator() {
    TrieNodeBaseIterator.call(this);
  }
  protoOf(TrieNodeEntriesIterator).v = function () {
    assert(this.v4y());
    this.xvh_1 = this.xvh_1 + 2 | 0;
    return new MapEntry(this.vvh_1[this.xvh_1 - 2 | 0], this.vvh_1[this.xvh_1 - 1 | 0]);
  };
  function MapEntry(key, value) {
    this.lvi_1 = key;
    this.mvi_1 = value;
  }
  protoOf(MapEntry).t1 = function () {
    return this.lvi_1;
  };
  protoOf(MapEntry).u1 = function () {
    return this.mvi_1;
  };
  protoOf(MapEntry).hashCode = function () {
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.t1();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    var tmp = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver_0 = this.u1();
    var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
    return tmp ^ (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0);
  };
  protoOf(MapEntry).equals = function (other) {
    var tmp0_safe_receiver = (!(other == null) ? isInterface(other, Entry) : false) ? other : null;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = (equals(tmp0_safe_receiver.t1(), this.t1()) && equals(tmp0_safe_receiver.u1(), this.u1()));
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  };
  protoOf(MapEntry).toString = function () {
    return toString(this.t1()) + '=' + toString(this.u1());
  };
  function PersistentHashMapKeys(map) {
    AbstractSet.call(this);
    this.avj_1 = map;
  }
  protoOf(PersistentHashMapKeys).n1 = function () {
    return this.avj_1.cvg_1;
  };
  protoOf(PersistentHashMapKeys).d6 = function (element) {
    return this.avj_1.u2(element);
  };
  protoOf(PersistentHashMapKeys).m1 = function (element) {
    if (!true)
      return false;
    return this.d6(element);
  };
  protoOf(PersistentHashMapKeys).t = function () {
    return new PersistentHashMapKeysIterator(this.avj_1.bvg_1);
  };
  function PersistentHashMapValues(map) {
    AbstractCollection.call(this);
    this.bvj_1 = map;
  }
  protoOf(PersistentHashMapValues).n1 = function () {
    return this.bvj_1.cvg_1;
  };
  protoOf(PersistentHashMapValues).j6 = function (element) {
    return this.bvj_1.v2(element);
  };
  protoOf(PersistentHashMapValues).m1 = function (element) {
    if (!true)
      return false;
    return this.j6(element);
  };
  protoOf(PersistentHashMapValues).t = function () {
    return new PersistentHashMapValuesIterator(this.bvj_1.bvg_1);
  };
  function PersistentHashMapEntries(map) {
    AbstractSet.call(this);
    this.cvj_1 = map;
  }
  protoOf(PersistentHashMapEntries).n1 = function () {
    return this.cvj_1.cvg_1;
  };
  protoOf(PersistentHashMapEntries).m14 = function (element) {
    return MapImplementation_instance.ovi(this.cvj_1, element);
  };
  protoOf(PersistentHashMapEntries).m1 = function (element) {
    if (!(!(element == null) ? isInterface(element, Entry) : false))
      return false;
    return this.m14((!(element == null) ? isInterface(element, Entry) : false) ? element : THROW_CCE());
  };
  protoOf(PersistentHashMapEntries).t = function () {
    return new PersistentHashMapEntriesIterator(this.cvj_1.bvg_1);
  };
  function TrieNode_init_$Init$(dataMap, nodeMap, buffer, $this) {
    TrieNode.call($this, dataMap, nodeMap, buffer, null);
    return $this;
  }
  function TrieNode_init_$Create$(dataMap, nodeMap, buffer) {
    return TrieNode_init_$Init$(dataMap, nodeMap, buffer, objectCreate(protoOf(TrieNode)));
  }
  function ModificationResult(node, sizeDelta) {
    this.hvg_1 = node;
    this.ivg_1 = sizeDelta;
  }
  function asInsertResult($this) {
    return new ModificationResult($this, 1);
  }
  function asUpdateResult($this) {
    return new ModificationResult($this, 0);
  }
  function hasNodeAt($this, positionMask) {
    return !(($this.evg_1 & positionMask) === 0);
  }
  function keyAtIndex($this, keyIndex) {
    return $this.gvg_1[keyIndex];
  }
  function valueAtKeyIndex($this, keyIndex) {
    return $this.gvg_1[keyIndex + 1 | 0];
  }
  function insertEntryAt($this, positionMask, key, value) {
    var keyIndex = $this.yvh(positionMask);
    var newBuffer = insertEntryAtIndex($this.gvg_1, keyIndex, key, value);
    return TrieNode_init_$Create$($this.dvg_1 | positionMask, $this.evg_1, newBuffer);
  }
  function mutableInsertEntryAt($this, positionMask, key, value, owner) {
    var keyIndex = $this.yvh(positionMask);
    if ($this.fvg_1 === owner) {
      $this.gvg_1 = insertEntryAtIndex($this.gvg_1, keyIndex, key, value);
      $this.dvg_1 = $this.dvg_1 | positionMask;
      return $this;
    }
    var newBuffer = insertEntryAtIndex($this.gvg_1, keyIndex, key, value);
    return new TrieNode($this.dvg_1 | positionMask, $this.evg_1, newBuffer, owner);
  }
  function updateValueAtIndex($this, keyIndex, value) {
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var newBuffer = $this.gvg_1.slice();
    newBuffer[keyIndex + 1 | 0] = value;
    return TrieNode_init_$Create$($this.dvg_1, $this.evg_1, newBuffer);
  }
  function mutableUpdateValueAtIndex($this, keyIndex, value, mutator) {
    if ($this.fvg_1 === mutator.ovg_1) {
      $this.gvg_1[keyIndex + 1 | 0] = value;
      return $this;
    }
    mutator.rvg_1 = mutator.rvg_1 + 1 | 0;
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var newBuffer = $this.gvg_1.slice();
    newBuffer[keyIndex + 1 | 0] = value;
    return new TrieNode($this.dvg_1, $this.evg_1, newBuffer, mutator.ovg_1);
  }
  function updateNodeAtIndex($this, nodeIndex, positionMask, newNode, owner) {
    owner = owner === VOID ? null : owner;
    var newNodeBuffer = newNode.gvg_1;
    if (newNodeBuffer.length === 2 && newNode.evg_1 === 0) {
      if ($this.gvg_1.length === 1) {
        newNode.dvg_1 = $this.evg_1;
        return newNode;
      }
      var keyIndex = $this.yvh(positionMask);
      var newBuffer = replaceNodeWithEntry($this.gvg_1, nodeIndex, keyIndex, newNodeBuffer[0], newNodeBuffer[1]);
      return new TrieNode($this.dvg_1 ^ positionMask, $this.evg_1 ^ positionMask, newBuffer, owner);
    }
    if (!(owner == null) && $this.fvg_1 === owner) {
      $this.gvg_1[nodeIndex] = newNode;
      return $this;
    }
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var newBuffer_0 = $this.gvg_1.slice();
    newBuffer_0[nodeIndex] = newNode;
    return new TrieNode($this.dvg_1, $this.evg_1, newBuffer_0, owner);
  }
  function removeNodeAtIndex($this, nodeIndex, positionMask) {
    if ($this.gvg_1.length === 1)
      return null;
    var newBuffer = removeNodeAtIndex_0($this.gvg_1, nodeIndex);
    return TrieNode_init_$Create$($this.dvg_1, $this.evg_1 ^ positionMask, newBuffer);
  }
  function mutableRemoveNodeAtIndex($this, nodeIndex, positionMask, owner) {
    if ($this.gvg_1.length === 1)
      return null;
    if ($this.fvg_1 === owner) {
      $this.gvg_1 = removeNodeAtIndex_0($this.gvg_1, nodeIndex);
      $this.evg_1 = $this.evg_1 ^ positionMask;
      return $this;
    }
    var newBuffer = removeNodeAtIndex_0($this.gvg_1, nodeIndex);
    return new TrieNode($this.dvg_1, $this.evg_1 ^ positionMask, newBuffer, owner);
  }
  function bufferMoveEntryToNode($this, keyIndex, positionMask, newKeyHash, newKey, newValue, shift, owner) {
    var storedKey = keyAtIndex($this, keyIndex);
    // Inline function 'kotlin.hashCode' call
    var tmp1_elvis_lhs = storedKey == null ? null : hashCode(storedKey);
    var storedKeyHash = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var storedValue = valueAtKeyIndex($this, keyIndex);
    var newNode = makeNode($this, storedKeyHash, storedKey, storedValue, newKeyHash, newKey, newValue, shift + 5 | 0, owner);
    var nodeIndex = $this.bvi(positionMask) + 1 | 0;
    return replaceEntryWithNode($this.gvg_1, keyIndex, nodeIndex, newNode);
  }
  function moveEntryToNode($this, keyIndex, positionMask, newKeyHash, newKey, newValue, shift) {
    var newBuffer = bufferMoveEntryToNode($this, keyIndex, positionMask, newKeyHash, newKey, newValue, shift, null);
    return TrieNode_init_$Create$($this.dvg_1 ^ positionMask, $this.evg_1 | positionMask, newBuffer);
  }
  function mutableMoveEntryToNode($this, keyIndex, positionMask, newKeyHash, newKey, newValue, shift, owner) {
    if ($this.fvg_1 === owner) {
      $this.gvg_1 = bufferMoveEntryToNode($this, keyIndex, positionMask, newKeyHash, newKey, newValue, shift, owner);
      $this.dvg_1 = $this.dvg_1 ^ positionMask;
      $this.evg_1 = $this.evg_1 | positionMask;
      return $this;
    }
    var newBuffer = bufferMoveEntryToNode($this, keyIndex, positionMask, newKeyHash, newKey, newValue, shift, owner);
    return new TrieNode($this.dvg_1 ^ positionMask, $this.evg_1 | positionMask, newBuffer, owner);
  }
  function makeNode($this, keyHash1, key1, value1, keyHash2, key2, value2, shift, owner) {
    if (shift > 30) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$0 = [key1, value1, key2, value2];
      return new TrieNode(0, 0, tmp$ret$0, owner);
    }
    var setBit1 = indexSegment(keyHash1, shift);
    var setBit2 = indexSegment(keyHash2, shift);
    if (!(setBit1 === setBit2)) {
      var tmp;
      if (setBit1 < setBit2) {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp = [key1, value1, key2, value2];
      } else {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp = [key2, value2, key1, value1];
      }
      var nodeBuffer = tmp;
      return new TrieNode(1 << setBit1 | 1 << setBit2, 0, nodeBuffer, owner);
    }
    var node = makeNode($this, keyHash1, key1, value1, keyHash2, key2, value2, shift + 5 | 0, owner);
    var tmp_0 = 1 << setBit1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [node];
    return new TrieNode(0, tmp_0, tmp$ret$9, owner);
  }
  function removeEntryAtIndex($this, keyIndex, positionMask) {
    if ($this.gvg_1.length === 2)
      return null;
    var newBuffer = removeEntryAtIndex_0($this.gvg_1, keyIndex);
    return TrieNode_init_$Create$($this.dvg_1 ^ positionMask, $this.evg_1, newBuffer);
  }
  function mutableRemoveEntryAtIndex($this, keyIndex, positionMask, mutator) {
    var _unary__edvuaz = mutator.svg_1;
    mutator.o4x(_unary__edvuaz - 1 | 0);
    mutator.qvg_1 = valueAtKeyIndex($this, keyIndex);
    if ($this.gvg_1.length === 2)
      return null;
    if ($this.fvg_1 === mutator.ovg_1) {
      $this.gvg_1 = removeEntryAtIndex_0($this.gvg_1, keyIndex);
      $this.dvg_1 = $this.dvg_1 ^ positionMask;
      return $this;
    }
    var newBuffer = removeEntryAtIndex_0($this.gvg_1, keyIndex);
    return new TrieNode($this.dvg_1 ^ positionMask, $this.evg_1, newBuffer, mutator.ovg_1);
  }
  function collisionRemoveEntryAtIndex($this, i) {
    if ($this.gvg_1.length === 2)
      return null;
    var newBuffer = removeEntryAtIndex_0($this.gvg_1, i);
    return TrieNode_init_$Create$(0, 0, newBuffer);
  }
  function mutableCollisionRemoveEntryAtIndex($this, i, mutator) {
    var _unary__edvuaz = mutator.svg_1;
    mutator.o4x(_unary__edvuaz - 1 | 0);
    mutator.qvg_1 = valueAtKeyIndex($this, i);
    if ($this.gvg_1.length === 2)
      return null;
    if ($this.fvg_1 === mutator.ovg_1) {
      $this.gvg_1 = removeEntryAtIndex_0($this.gvg_1, i);
      return $this;
    }
    var newBuffer = removeEntryAtIndex_0($this.gvg_1, i);
    return new TrieNode(0, 0, newBuffer, mutator.ovg_1);
  }
  function collisionKeyIndex($this, key) {
    var progression = step(until(0, $this.gvg_1.length), 2);
    var inductionVariable = progression.x1_1;
    var last = progression.y1_1;
    var step_0 = progression.z1_1;
    if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        if (equals(key, keyAtIndex($this, i)))
          return i;
      }
       while (!(i === last));
    return -1;
  }
  function collisionContainsKey($this, key) {
    return !(collisionKeyIndex($this, key) === -1);
  }
  function collisionGet($this, key) {
    var keyIndex = collisionKeyIndex($this, key);
    return !(keyIndex === -1) ? valueAtKeyIndex($this, keyIndex) : null;
  }
  function collisionPut($this, key, value) {
    var keyIndex = collisionKeyIndex($this, key);
    if (!(keyIndex === -1)) {
      if (value === valueAtKeyIndex($this, keyIndex)) {
        return null;
      }
      // Inline function 'kotlin.collections.copyOf' call
      // Inline function 'kotlin.js.asDynamic' call
      var newBuffer = $this.gvg_1.slice();
      newBuffer[keyIndex + 1 | 0] = value;
      return asUpdateResult(TrieNode_init_$Create$(0, 0, newBuffer));
    }
    var newBuffer_0 = insertEntryAtIndex($this.gvg_1, 0, key, value);
    return asInsertResult(TrieNode_init_$Create$(0, 0, newBuffer_0));
  }
  function mutableCollisionPut($this, key, value, mutator) {
    var keyIndex = collisionKeyIndex($this, key);
    if (!(keyIndex === -1)) {
      mutator.qvg_1 = valueAtKeyIndex($this, keyIndex);
      if ($this.fvg_1 === mutator.ovg_1) {
        $this.gvg_1[keyIndex + 1 | 0] = value;
        return $this;
      }
      mutator.rvg_1 = mutator.rvg_1 + 1 | 0;
      // Inline function 'kotlin.collections.copyOf' call
      // Inline function 'kotlin.js.asDynamic' call
      var newBuffer = $this.gvg_1.slice();
      newBuffer[keyIndex + 1 | 0] = value;
      return new TrieNode(0, 0, newBuffer, mutator.ovg_1);
    }
    var _unary__edvuaz = mutator.svg_1;
    mutator.o4x(_unary__edvuaz + 1 | 0);
    var newBuffer_0 = insertEntryAtIndex($this.gvg_1, 0, key, value);
    return new TrieNode(0, 0, newBuffer_0, mutator.ovg_1);
  }
  function collisionRemove($this, key) {
    var keyIndex = collisionKeyIndex($this, key);
    if (!(keyIndex === -1)) {
      return collisionRemoveEntryAtIndex($this, keyIndex);
    }
    return $this;
  }
  function mutableCollisionRemove($this, key, mutator) {
    var keyIndex = collisionKeyIndex($this, key);
    if (!(keyIndex === -1)) {
      return mutableCollisionRemoveEntryAtIndex($this, keyIndex, mutator);
    }
    return $this;
  }
  function mutableCollisionRemove_0($this, key, value, mutator) {
    var keyIndex = collisionKeyIndex($this, key);
    if (!(keyIndex === -1) && equals(value, valueAtKeyIndex($this, keyIndex))) {
      return mutableCollisionRemoveEntryAtIndex($this, keyIndex, mutator);
    }
    return $this;
  }
  function mutableCollisionPutAll($this, otherNode, intersectionCounter, owner) {
    assert($this.evg_1 === 0);
    assert($this.dvg_1 === 0);
    assert(otherNode.evg_1 === 0);
    assert(otherNode.dvg_1 === 0);
    var tempBuffer = copyOf($this.gvg_1, $this.gvg_1.length + otherNode.gvg_1.length | 0);
    var i = $this.gvg_1.length;
    var progression = step(until(0, otherNode.gvg_1.length), 2);
    var inductionVariable = progression.x1_1;
    var last = progression.y1_1;
    var step_0 = progression.z1_1;
    if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
      do {
        var j = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        if (!collisionContainsKey($this, otherNode.gvg_1[j])) {
          tempBuffer[i] = otherNode.gvg_1[j];
          tempBuffer[i + 1 | 0] = otherNode.gvg_1[j + 1 | 0];
          i = i + 2 | 0;
        } else {
          intersectionCounter.fvh_1 = intersectionCounter.fvh_1 + 1 | 0;
        }
      }
       while (!(j === last));
    var newSize = i;
    return newSize === $this.gvg_1.length ? $this : newSize === otherNode.gvg_1.length ? otherNode : newSize === tempBuffer.length ? new TrieNode(0, 0, tempBuffer, owner) : new TrieNode(0, 0, copyOf(tempBuffer, newSize), owner);
  }
  function mutablePutAllFromOtherNodeCell($this, otherNode, positionMask, shift, intersectionCounter, mutator) {
    var tmp;
    if (hasNodeAt($this, positionMask)) {
      var targetNode = $this.cvi($this.bvi(positionMask));
      var tmp_0;
      if (hasNodeAt(otherNode, positionMask)) {
        var otherTargetNode = otherNode.cvi(otherNode.bvi(positionMask));
        tmp_0 = targetNode.evh(otherTargetNode, shift + 5 | 0, intersectionCounter, mutator);
      } else if (otherNode.avi(positionMask)) {
        var keyIndex = otherNode.yvh(positionMask);
        var key = keyAtIndex(otherNode, keyIndex);
        var value = valueAtKeyIndex(otherNode, keyIndex);
        var oldSize = mutator.svg_1;
        // Inline function 'kotlin.hashCode' call
        var tmp1_elvis_lhs = key == null ? null : hashCode(key);
        var tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
        // Inline function 'kotlin.also' call
        var this_0 = targetNode.dvh(tmp$ret$0, key, value, shift + 5 | 0, mutator);
        if (mutator.svg_1 === oldSize) {
          intersectionCounter.fvh_1 = intersectionCounter.fvh_1 + 1 | 0;
        }
        tmp_0 = this_0;
      } else {
        tmp_0 = targetNode;
      }
      tmp = tmp_0;
    } else if (hasNodeAt(otherNode, positionMask)) {
      var otherTargetNode_0 = otherNode.cvi(otherNode.bvi(positionMask));
      var tmp_1;
      if ($this.avi(positionMask)) {
        var keyIndex_0 = $this.yvh(positionMask);
        var key_0 = keyAtIndex($this, keyIndex_0);
        var tmp_2;
        // Inline function 'kotlin.hashCode' call
        var tmp1_elvis_lhs_0 = key_0 == null ? null : hashCode(key_0);
        var tmp$ret$3 = tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0;
        if (otherTargetNode_0.y4w(tmp$ret$3, key_0, shift + 5 | 0)) {
          intersectionCounter.fvh_1 = intersectionCounter.fvh_1 + 1 | 0;
          tmp_2 = otherTargetNode_0;
        } else {
          var value_0 = valueAtKeyIndex($this, keyIndex_0);
          // Inline function 'kotlin.hashCode' call
          var tmp1_elvis_lhs_1 = key_0 == null ? null : hashCode(key_0);
          var tmp$ret$4 = tmp1_elvis_lhs_1 == null ? 0 : tmp1_elvis_lhs_1;
          tmp_2 = otherTargetNode_0.dvh(tmp$ret$4, key_0, value_0, shift + 5 | 0, mutator);
        }
        tmp_1 = tmp_2;
      } else {
        tmp_1 = otherTargetNode_0;
      }
      tmp = tmp_1;
    } else {
      var thisKeyIndex = $this.yvh(positionMask);
      var thisKey = keyAtIndex($this, thisKeyIndex);
      var thisValue = valueAtKeyIndex($this, thisKeyIndex);
      var otherKeyIndex = otherNode.yvh(positionMask);
      var otherKey = keyAtIndex(otherNode, otherKeyIndex);
      var otherValue = valueAtKeyIndex(otherNode, otherKeyIndex);
      // Inline function 'kotlin.hashCode' call
      var tmp1_elvis_lhs_2 = thisKey == null ? null : hashCode(thisKey);
      var tmp_3 = tmp1_elvis_lhs_2 == null ? 0 : tmp1_elvis_lhs_2;
      // Inline function 'kotlin.hashCode' call
      var tmp1_elvis_lhs_3 = otherKey == null ? null : hashCode(otherKey);
      var tmp$ret$6 = tmp1_elvis_lhs_3 == null ? 0 : tmp1_elvis_lhs_3;
      tmp = makeNode($this, tmp_3, thisKey, thisValue, tmp$ret$6, otherKey, otherValue, shift + 5 | 0, mutator.ovg_1);
    }
    return tmp;
  }
  function calculateSize($this) {
    if ($this.evg_1 === 0)
      return $this.gvg_1.length / 2 | 0;
    var numValues = countOneBits($this.dvg_1);
    var result = numValues;
    var inductionVariable = imul(numValues, 2);
    var last = $this.gvg_1.length;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        result = result + calculateSize($this.cvi(i)) | 0;
      }
       while (inductionVariable < last);
    return result;
  }
  function elementsIdentityEquals($this, otherNode) {
    if ($this === otherNode)
      return true;
    if (!($this.evg_1 === otherNode.evg_1))
      return false;
    if (!($this.dvg_1 === otherNode.dvg_1))
      return false;
    var inductionVariable = 0;
    var last = $this.gvg_1.length;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!($this.gvg_1[i] === otherNode.gvg_1[i]))
          return false;
      }
       while (inductionVariable < last);
    return true;
  }
  function replaceNode($this, targetNode, newNode, nodeIndex, positionMask) {
    return newNode == null ? removeNodeAtIndex($this, nodeIndex, positionMask) : !(targetNode === newNode) ? updateNodeAtIndex($this, nodeIndex, positionMask, newNode) : $this;
  }
  function mutableReplaceNode($this, newNode, nodeIndex, positionMask, owner) {
    return newNode == null ? mutableRemoveNodeAtIndex($this, nodeIndex, positionMask, owner) : updateNodeAtIndex($this, nodeIndex, positionMask, newNode, owner);
  }
  function Companion_0() {
    Companion_instance_0 = this;
    var tmp = this;
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    tmp.vvf_1 = TrieNode_init_$Create$(0, 0, tmp$ret$0);
  }
  var Companion_instance_0;
  function Companion_getInstance_0() {
    if (Companion_instance_0 == null)
      new Companion_0();
    return Companion_instance_0;
  }
  function TrieNode(dataMap, nodeMap, buffer, ownedBy) {
    Companion_getInstance_0();
    this.dvg_1 = dataMap;
    this.evg_1 = nodeMap;
    this.fvg_1 = ownedBy;
    this.gvg_1 = buffer;
  }
  protoOf(TrieNode).zvh = function () {
    return countOneBits(this.dvg_1);
  };
  protoOf(TrieNode).avi = function (positionMask) {
    return !((this.dvg_1 & positionMask) === 0);
  };
  protoOf(TrieNode).yvh = function (positionMask) {
    return imul(2, countOneBits(this.dvg_1 & (positionMask - 1 | 0)));
  };
  protoOf(TrieNode).bvi = function (positionMask) {
    return (this.gvg_1.length - 1 | 0) - countOneBits(this.evg_1 & (positionMask - 1 | 0)) | 0;
  };
  protoOf(TrieNode).cvi = function (nodeIndex) {
    var tmp = this.gvg_1[nodeIndex];
    return tmp instanceof TrieNode ? tmp : THROW_CCE();
  };
  protoOf(TrieNode).y4w = function (keyHash, key, shift) {
    var keyPositionMask = 1 << indexSegment(keyHash, shift);
    if (this.avi(keyPositionMask)) {
      return equals(key, keyAtIndex(this, this.yvh(keyPositionMask)));
    }
    if (hasNodeAt(this, keyPositionMask)) {
      var targetNode = this.cvi(this.bvi(keyPositionMask));
      if (shift === 30) {
        return collisionContainsKey(targetNode, key);
      }
      return targetNode.y4w(keyHash, key, shift + 5 | 0);
    }
    return false;
  };
  protoOf(TrieNode).z4w = function (keyHash, key, shift) {
    var keyPositionMask = 1 << indexSegment(keyHash, shift);
    if (this.avi(keyPositionMask)) {
      var keyIndex = this.yvh(keyPositionMask);
      if (equals(key, keyAtIndex(this, keyIndex))) {
        return valueAtKeyIndex(this, keyIndex);
      }
      return null;
    }
    if (hasNodeAt(this, keyPositionMask)) {
      var targetNode = this.cvi(this.bvi(keyPositionMask));
      if (shift === 30) {
        return collisionGet(targetNode, key);
      }
      return targetNode.z4w(keyHash, key, shift + 5 | 0);
    }
    return null;
  };
  protoOf(TrieNode).evh = function (otherNode, shift, intersectionCounter, mutator) {
    if (this === otherNode) {
      intersectionCounter.w4z(calculateSize(this));
      return this;
    }
    if (shift > 30) {
      return mutableCollisionPutAll(this, otherNode, intersectionCounter, mutator.ovg_1);
    }
    var newNodeMap = this.evg_1 | otherNode.evg_1;
    var newDataMap = (this.dvg_1 ^ otherNode.dvg_1) & ~newNodeMap;
    // Inline function 'kotlinx.collections.immutable.internal.forEachOneBit' call
    var mask = this.dvg_1 & otherNode.dvg_1;
    var index = 0;
    while (!(mask === 0)) {
      var bit = takeLowestOneBit(mask);
      var leftKey = keyAtIndex(this, this.yvh(bit));
      var rightKey = keyAtIndex(otherNode, otherNode.yvh(bit));
      if (equals(leftKey, rightKey))
        newDataMap = newDataMap | bit;
      else
        newNodeMap = newNodeMap | bit;
      index = index + 1 | 0;
      mask = mask ^ bit;
    }
    // Inline function 'kotlin.check' call
    if (!((newNodeMap & newDataMap) === 0)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    var tmp;
    if (equals(this.fvg_1, mutator.ovg_1) && this.dvg_1 === newDataMap && this.evg_1 === newNodeMap) {
      tmp = this;
    } else {
      // Inline function 'kotlin.arrayOfNulls' call
      var size = imul(countOneBits(newDataMap), 2) + countOneBits(newNodeMap) | 0;
      var newBuffer = Array(size);
      tmp = TrieNode_init_$Create$(newDataMap, newNodeMap, newBuffer);
    }
    var mutableNode = tmp;
    // Inline function 'kotlinx.collections.immutable.internal.forEachOneBit' call
    var mask_0 = newNodeMap;
    var index_0 = 0;
    while (!(mask_0 === 0)) {
      var bit_0 = takeLowestOneBit(mask_0);
      var index_1 = index_0;
      var newNodeIndex = (mutableNode.gvg_1.length - 1 | 0) - index_1 | 0;
      mutableNode.gvg_1[newNodeIndex] = mutablePutAllFromOtherNodeCell(this, otherNode, bit_0, shift, intersectionCounter, mutator);
      index_0 = index_0 + 1 | 0;
      mask_0 = mask_0 ^ bit_0;
    }
    // Inline function 'kotlinx.collections.immutable.internal.forEachOneBit' call
    var mask_1 = newDataMap;
    var index_2 = 0;
    while (!(mask_1 === 0)) {
      var bit_1 = takeLowestOneBit(mask_1);
      var index_3 = index_2;
      var newKeyIndex = imul(index_3, 2);
      if (!otherNode.avi(bit_1)) {
        var oldKeyIndex = this.yvh(bit_1);
        mutableNode.gvg_1[newKeyIndex] = keyAtIndex(this, oldKeyIndex);
        mutableNode.gvg_1[newKeyIndex + 1 | 0] = valueAtKeyIndex(this, oldKeyIndex);
      } else {
        var oldKeyIndex_0 = otherNode.yvh(bit_1);
        mutableNode.gvg_1[newKeyIndex] = keyAtIndex(otherNode, oldKeyIndex_0);
        mutableNode.gvg_1[newKeyIndex + 1 | 0] = valueAtKeyIndex(otherNode, oldKeyIndex_0);
        if (this.avi(bit_1)) {
          intersectionCounter.fvh_1 = intersectionCounter.fvh_1 + 1 | 0;
        }
      }
      index_2 = index_2 + 1 | 0;
      mask_1 = mask_1 ^ bit_1;
    }
    return elementsIdentityEquals(this, mutableNode) ? this : elementsIdentityEquals(otherNode, mutableNode) ? otherNode : mutableNode;
  };
  protoOf(TrieNode).a4x = function (keyHash, key, value, shift) {
    var keyPositionMask = 1 << indexSegment(keyHash, shift);
    if (this.avi(keyPositionMask)) {
      var keyIndex = this.yvh(keyPositionMask);
      if (equals(key, keyAtIndex(this, keyIndex))) {
        if (valueAtKeyIndex(this, keyIndex) === value)
          return null;
        return asUpdateResult(updateValueAtIndex(this, keyIndex, value));
      }
      return asInsertResult(moveEntryToNode(this, keyIndex, keyPositionMask, keyHash, key, value, shift));
    }
    if (hasNodeAt(this, keyPositionMask)) {
      var nodeIndex = this.bvi(keyPositionMask);
      var targetNode = this.cvi(nodeIndex);
      var tmp;
      if (shift === 30) {
        var tmp0_elvis_lhs = collisionPut(targetNode, key, value);
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          return null;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        tmp = tmp_0;
      } else {
        var tmp1_elvis_lhs = targetNode.a4x(keyHash, key, value, shift + 5 | 0);
        var tmp_1;
        if (tmp1_elvis_lhs == null) {
          return null;
        } else {
          tmp_1 = tmp1_elvis_lhs;
        }
        tmp = tmp_1;
      }
      var putResult = tmp;
      // Inline function 'kotlinx.collections.immutable.implementations.immutableMap.ModificationResult.replaceNode' call
      // Inline function 'kotlin.apply' call
      var tmp_2 = putResult;
      var node = putResult.hvg_1;
      tmp_2.hvg_1 = updateNodeAtIndex(this, nodeIndex, keyPositionMask, node);
      return putResult;
    }
    return asInsertResult(insertEntryAt(this, keyPositionMask, key, value));
  };
  protoOf(TrieNode).dvh = function (keyHash, key, value, shift, mutator) {
    var keyPositionMask = 1 << indexSegment(keyHash, shift);
    if (this.avi(keyPositionMask)) {
      var keyIndex = this.yvh(keyPositionMask);
      if (equals(key, keyAtIndex(this, keyIndex))) {
        mutator.qvg_1 = valueAtKeyIndex(this, keyIndex);
        if (valueAtKeyIndex(this, keyIndex) === value) {
          return this;
        }
        return mutableUpdateValueAtIndex(this, keyIndex, value, mutator);
      }
      var _unary__edvuaz = mutator.svg_1;
      mutator.o4x(_unary__edvuaz + 1 | 0);
      return mutableMoveEntryToNode(this, keyIndex, keyPositionMask, keyHash, key, value, shift, mutator.ovg_1);
    }
    if (hasNodeAt(this, keyPositionMask)) {
      var nodeIndex = this.bvi(keyPositionMask);
      var targetNode = this.cvi(nodeIndex);
      var tmp;
      if (shift === 30) {
        tmp = mutableCollisionPut(targetNode, key, value, mutator);
      } else {
        tmp = targetNode.dvh(keyHash, key, value, shift + 5 | 0, mutator);
      }
      var newNode = tmp;
      if (targetNode === newNode) {
        return this;
      }
      return updateNodeAtIndex(this, nodeIndex, keyPositionMask, newNode, mutator.ovg_1);
    }
    var _unary__edvuaz_0 = mutator.svg_1;
    mutator.o4x(_unary__edvuaz_0 + 1 | 0);
    return mutableInsertEntryAt(this, keyPositionMask, key, value, mutator.ovg_1);
  };
  protoOf(TrieNode).d4x = function (keyHash, key, shift) {
    var keyPositionMask = 1 << indexSegment(keyHash, shift);
    if (this.avi(keyPositionMask)) {
      var keyIndex = this.yvh(keyPositionMask);
      if (equals(key, keyAtIndex(this, keyIndex))) {
        return removeEntryAtIndex(this, keyIndex, keyPositionMask);
      }
      return this;
    }
    if (hasNodeAt(this, keyPositionMask)) {
      var nodeIndex = this.bvi(keyPositionMask);
      var targetNode = this.cvi(nodeIndex);
      var tmp;
      if (shift === 30) {
        tmp = collisionRemove(targetNode, key);
      } else {
        tmp = targetNode.d4x(keyHash, key, shift + 5 | 0);
      }
      var newNode = tmp;
      return replaceNode(this, targetNode, newNode, nodeIndex, keyPositionMask);
    }
    return this;
  };
  protoOf(TrieNode).gvh = function (keyHash, key, shift, mutator) {
    var keyPositionMask = 1 << indexSegment(keyHash, shift);
    if (this.avi(keyPositionMask)) {
      var keyIndex = this.yvh(keyPositionMask);
      if (equals(key, keyAtIndex(this, keyIndex))) {
        return mutableRemoveEntryAtIndex(this, keyIndex, keyPositionMask, mutator);
      }
      return this;
    }
    if (hasNodeAt(this, keyPositionMask)) {
      var nodeIndex = this.bvi(keyPositionMask);
      var targetNode = this.cvi(nodeIndex);
      var tmp;
      if (shift === 30) {
        tmp = mutableCollisionRemove(targetNode, key, mutator);
      } else {
        tmp = targetNode.gvh(keyHash, key, shift + 5 | 0, mutator);
      }
      var newNode = tmp;
      return mutableReplaceNode(this, newNode, nodeIndex, keyPositionMask, mutator.ovg_1);
    }
    return this;
  };
  protoOf(TrieNode).hvh = function (keyHash, key, value, shift, mutator) {
    var keyPositionMask = 1 << indexSegment(keyHash, shift);
    if (this.avi(keyPositionMask)) {
      var keyIndex = this.yvh(keyPositionMask);
      if (equals(key, keyAtIndex(this, keyIndex)) && equals(value, valueAtKeyIndex(this, keyIndex))) {
        return mutableRemoveEntryAtIndex(this, keyIndex, keyPositionMask, mutator);
      }
      return this;
    }
    if (hasNodeAt(this, keyPositionMask)) {
      var nodeIndex = this.bvi(keyPositionMask);
      var targetNode = this.cvi(nodeIndex);
      var tmp;
      if (shift === 30) {
        tmp = mutableCollisionRemove_0(targetNode, key, value, mutator);
      } else {
        tmp = targetNode.hvh(keyHash, key, value, shift + 5 | 0, mutator);
      }
      var newNode = tmp;
      return mutableReplaceNode(this, newNode, nodeIndex, keyPositionMask, mutator.ovg_1);
    }
    return this;
  };
  protoOf(TrieNode).tvg = function (that, equalityComparator) {
    if (this === that)
      return true;
    if (!(this.dvg_1 === that.dvg_1) || !(this.evg_1 === that.evg_1))
      return false;
    if (this.dvg_1 === 0 && this.evg_1 === 0) {
      if (!(this.gvg_1.length === that.gvg_1.length))
        return false;
      var tmp0 = step(until(0, this.gvg_1.length), 2);
      var tmp$ret$0;
      $l$block_0: {
        // Inline function 'kotlin.collections.all' call
        var tmp;
        if (isInterface(tmp0, Collection)) {
          tmp = tmp0.r();
        } else {
          tmp = false;
        }
        if (tmp) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
        var inductionVariable = tmp0.x1_1;
        var last = tmp0.y1_1;
        var step_0 = tmp0.z1_1;
        if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
          do {
            var element = inductionVariable;
            inductionVariable = inductionVariable + step_0 | 0;
            var i = element;
            var thatKey = keyAtIndex(that, i);
            var thatValue = valueAtKeyIndex(that, i);
            var keyIndex = collisionKeyIndex(this, thatKey);
            var tmp_0;
            if (!(keyIndex === -1)) {
              var value = valueAtKeyIndex(this, keyIndex);
              tmp_0 = equalityComparator(value, thatValue);
            } else {
              tmp_0 = false;
            }
            if (!tmp_0) {
              tmp$ret$0 = false;
              break $l$block_0;
            }
          }
           while (!(element === last));
        tmp$ret$0 = true;
      }
      return tmp$ret$0;
    }
    var valueSize = imul(countOneBits(this.dvg_1), 2);
    var progression = step(until(0, valueSize), 2);
    var inductionVariable_0 = progression.x1_1;
    var last_0 = progression.y1_1;
    var step_1 = progression.z1_1;
    if (step_1 > 0 && inductionVariable_0 <= last_0 || (step_1 < 0 && last_0 <= inductionVariable_0))
      do {
        var i_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + step_1 | 0;
        if (!equals(keyAtIndex(this, i_0), keyAtIndex(that, i_0)))
          return false;
        if (!equalityComparator(valueAtKeyIndex(this, i_0), valueAtKeyIndex(that, i_0)))
          return false;
      }
       while (!(i_0 === last_0));
    var inductionVariable_1 = valueSize;
    var last_1 = this.gvg_1.length;
    if (inductionVariable_1 < last_1)
      do {
        var i_1 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        if (!this.cvi(i_1).tvg(that.cvi(i_1), equalityComparator))
          return false;
      }
       while (inductionVariable_1 < last_1);
    return true;
  };
  function insertEntryAtIndex(_this__u8e3s4, keyIndex, key, value) {
    // Inline function 'kotlin.arrayOfNulls' call
    var size = _this__u8e3s4.length + 2 | 0;
    var newBuffer = Array(size);
    // Inline function 'kotlin.collections.copyInto' call
    arrayCopy(_this__u8e3s4, newBuffer, 0, 0, keyIndex);
    var tmp4 = keyIndex + 2 | 0;
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = _this__u8e3s4.length;
    arrayCopy(_this__u8e3s4, newBuffer, tmp4, keyIndex, endIndex);
    newBuffer[keyIndex] = key;
    newBuffer[keyIndex + 1 | 0] = value;
    return newBuffer;
  }
  function replaceNodeWithEntry(_this__u8e3s4, nodeIndex, keyIndex, key, value) {
    var newBuffer = copyOf(_this__u8e3s4, _this__u8e3s4.length + 1 | 0);
    var tmp4 = nodeIndex + 2 | 0;
    var tmp6 = nodeIndex + 1 | 0;
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = _this__u8e3s4.length;
    arrayCopy(newBuffer, newBuffer, tmp4, tmp6, endIndex);
    // Inline function 'kotlin.collections.copyInto' call
    var destinationOffset = keyIndex + 2 | 0;
    arrayCopy(newBuffer, newBuffer, destinationOffset, keyIndex, nodeIndex);
    newBuffer[keyIndex] = key;
    newBuffer[keyIndex + 1 | 0] = value;
    return newBuffer;
  }
  function removeNodeAtIndex_0(_this__u8e3s4, nodeIndex) {
    // Inline function 'kotlin.arrayOfNulls' call
    var size = _this__u8e3s4.length - 1 | 0;
    var newBuffer = Array(size);
    // Inline function 'kotlin.collections.copyInto' call
    arrayCopy(_this__u8e3s4, newBuffer, 0, 0, nodeIndex);
    var tmp6 = nodeIndex + 1 | 0;
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = _this__u8e3s4.length;
    arrayCopy(_this__u8e3s4, newBuffer, nodeIndex, tmp6, endIndex);
    return newBuffer;
  }
  function replaceEntryWithNode(_this__u8e3s4, keyIndex, nodeIndex, newNode) {
    var newNodeIndex = nodeIndex - 2 | 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var size = (_this__u8e3s4.length - 2 | 0) + 1 | 0;
    var newBuffer = Array(size);
    // Inline function 'kotlin.collections.copyInto' call
    arrayCopy(_this__u8e3s4, newBuffer, 0, 0, keyIndex);
    // Inline function 'kotlin.collections.copyInto' call
    var startIndex = keyIndex + 2 | 0;
    arrayCopy(_this__u8e3s4, newBuffer, keyIndex, startIndex, nodeIndex);
    newBuffer[newNodeIndex] = newNode;
    var tmp4 = newNodeIndex + 1 | 0;
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = _this__u8e3s4.length;
    arrayCopy(_this__u8e3s4, newBuffer, tmp4, nodeIndex, endIndex);
    return newBuffer;
  }
  function indexSegment(index, shift) {
    return index >> shift & 31;
  }
  function removeEntryAtIndex_0(_this__u8e3s4, keyIndex) {
    // Inline function 'kotlin.arrayOfNulls' call
    var size = _this__u8e3s4.length - 2 | 0;
    var newBuffer = Array(size);
    // Inline function 'kotlin.collections.copyInto' call
    arrayCopy(_this__u8e3s4, newBuffer, 0, 0, keyIndex);
    var tmp6 = keyIndex + 2 | 0;
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = _this__u8e3s4.length;
    arrayCopy(_this__u8e3s4, newBuffer, keyIndex, tmp6, endIndex);
    return newBuffer;
  }
  function PersistentOrderedMap() {
  }
  function PersistentOrderedMapBuilder() {
  }
  function MapImplementation() {
  }
  protoOf(MapImplementation).ovi = function (map, element) {
    var tmp = !(element == null) ? element : THROW_CCE();
    if (!(!(tmp == null) ? isInterface(tmp, Entry) : false))
      return false;
    var tmp0_safe_receiver = map.w2(element.t1());
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_0 = equals(tmp0_safe_receiver, element.u1());
    }
    var tmp1_elvis_lhs = tmp_0;
    return tmp1_elvis_lhs == null ? element.u1() == null && map.u2(element.t1()) : tmp1_elvis_lhs;
  };
  protoOf(MapImplementation).ivh = function (thisMap, otherMap) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(thisMap.n1() === otherMap.n1())) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$(toString_0(message));
    }
    var tmp0 = isInterface(otherMap, KtMap) ? otherMap : THROW_CCE();
    var tmp$ret$3;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      if (tmp0.r()) {
        tmp$ret$3 = true;
        break $l$block_0;
      }
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s = tmp0.s1().t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        if (!MapImplementation_instance.ovi(thisMap, element)) {
          tmp$ret$3 = false;
          break $l$block_0;
        }
      }
      tmp$ret$3 = true;
    }
    return tmp$ret$3;
  };
  protoOf(MapImplementation).jvh = function (map) {
    return hashCode(map.s1());
  };
  var MapImplementation_instance;
  function MapImplementation_getInstance() {
    return MapImplementation_instance;
  }
  function MutabilityOwnership() {
  }
  function DeltaCounter(count) {
    count = count === VOID ? 0 : count;
    this.fvh_1 = count;
  }
  protoOf(DeltaCounter).w4z = function (that) {
    this.fvh_1 = this.fvh_1 + that | 0;
  };
  protoOf(DeltaCounter).toString = function () {
    return 'DeltaCounter(count=' + this.fvh_1 + ')';
  };
  protoOf(DeltaCounter).hashCode = function () {
    return this.fvh_1;
  };
  protoOf(DeltaCounter).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DeltaCounter))
      return false;
    var tmp0_other_with_cast = other instanceof DeltaCounter ? other : THROW_CCE();
    if (!(this.fvh_1 === tmp0_other_with_cast.fvh_1))
      return false;
    return true;
  };
  function assert(condition) {
    if (!condition) {
      throw AssertionError_init_$Create$('Assertion failed');
    }
  }
  //region block: init
  MapImplementation_instance = new MapImplementation();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = persistentHashMapOf;
  _.$_$.b = persistentHashMapOf_0;
  //endregion
  return _;
}));

//# sourceMappingURL=Kotlin-Immutable-Collections-kotlinx-collections-immutable.js.map
